import React from 'react';
import SongArt from "../../../atoms/SongArt";
import {song} from "../../../../data/song_dump";

interface Props {
    title: string;
    author: string;
    art_url: string;
    small?: boolean;
    compact?: boolean;
}

const SongInfoArt = ({title, author, art_url, small = false, compact = false}: Props) => {
    const songTitle = title || song.title;
    const songAuthor = author || song.artist;
    const maxWidthClass = compact
        ? 'max-w-[140px] sm:max-w-[160px] lg:max-w-[180px]'
        : 'max-w-[52vw] sm:max-w-[240px] lg:max-w-[280px]';

    return (
        <div className={'flex min-w-0 justify-start sm:justify-end items-center mb-2 lg:mb-0 sm:mb-0'}>
            <SongArt small art={art_url || song.song_art || song.album_art}/>
            <div className="flex min-w-0 flex-col justify-center">
                <div
                    className={`${small ? 'text-[18px] sm:text-[12px]' : 'text-md sm:text-sm'} ${maxWidthClass} truncate font-medium text-gray-900 dark:text-white`}
                    title={songTitle}
                >{songTitle}
                </div>
                <div
                    className={`${small ? 'text-[12px] sm:text-[8px]' : 'small_text'} ${maxWidthClass} truncate text-gray-500 dark:text-gray-400`}
                    title={songAuthor}
                >{songAuthor}
                </div>
            </div>
        </div>
    );
};

export default SongInfoArt;
